import React from 'react';

export default function HeroSection() {
  return (
    <section className="hero-section">
      <div
        className="hero-bg"
        style={{
          backgroundImage: `url('https://coffeebythebay.com/cdn/shop/files/3B6778B8-031A-415B-8136-F774D9BDB734_1296x.JPG?v=1615924298')`,
          backgroundPosition: 'center bottom',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="hero-overlay" />
        <div className="hero-inner">
          <h2 className="hero-title">Bayside Coffee Co.</h2>
        </div>
      </div>

      <style jsx>{`
        .hero-section {
          width: 100%;
          position: relative;
        }
        .hero-bg {
          position: relative;
          width: 100%;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .hero-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.15);
        }
        .hero-inner {
          position: relative;
          z-index: 1;
          text-align: center;
          padding: 60px 20px;
        }
        .hero-title {
          color: #fff;
          font-family: 'Work Sans', sans-serif;
          font-size: 65px;
          font-weight: 600;
          margin: 0;
          line-height: 1.1;
          text-shadow: 0 2px 8px rgba(0,0,0,0.3);
        }
        @media (max-width: 749px) {
          .hero-bg {
            min-height: 320px;
          }
          .hero-title {
            font-size: 36px;
          }
        }
      `}</style>
    </section>
  );
}
